export default __webpack_public_path__ + "static/media/sanmat17.05e29fe5.jpg";